type Format = "png" | "tiff" | "zoning";

export type ViewerConfig = {
  search: {
    enabled: boolean;
    fuzzy: boolean;
    fillColor: string;
    strokeColor: string;
    threshold: number;
  },
  controls: {
    enabled?: boolean;
    rotate: boolean;
    zoom: boolean;
    download: boolean;
    format?: Format[];
  },
  multipage?: {
    enabled?: boolean;
  },
  highlight: {
    enabled: boolean;
    fuzzy: boolean;
    fillColor: string;
    strokeColor: string;
    threshold: number;
  },
  extracted: {
    enabled: boolean;
    fuzzy: boolean;
    fillColor: string;
    strokeColor: string;
    threshold: number;
  }
};

export default {
  INACTIVITY_TIMEOUT: {
    ENABLED: true, // Enable inactivity timeout
    TIMEOUT: 30 * 60 * 1000, // 30 minutes
    INTERVAL: 1 * 60 * 1000, // 1 minute
  },
};
